import React, {useCallback} from 'react';
import styled from 'styled-components';
import Button from 'components/Button';

import Icon from 'react-icons-kit';
import {ic_close} from 'react-icons-kit/md/ic_close';
import {removeEntityId} from 'state/selections/actions';
import {useDispatch} from 'react-redux';
const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const DeleteCellRenderer = (props) => {
  const dispatch = useDispatch();
  const {data} = props;
  const {entityId} = data ?? {};
  const onButtonClick = useCallback(() => {
    dispatch(removeEntityId(entityId));
  }, [entityId, dispatch]);
  return (
    <Root>
      <Button
        size={"S"}
        onButtonClick={onButtonClick}
        icon={<Icon icon={ic_close} size={18}/>}
        variation={0}
      />
    </Root>
  );
};

export default DeleteCellRenderer;
